<template>
  <!-- ホーム画面 -->
  <div id="cpapTempInstalledHome">
    <div id="container">
      <div class="title is-3">CPAP 仮持出メニュー</div>
      <div class="grid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentRequest', params:{agent:true, temp:true, cpapAgentReqFlg:this.cpapAgentReqFlg}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-playlist-edit mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">新規処方申込み</div>
                </router-link>
              </div>
            </li>
            <!--
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentInstrumentRequest', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-book-edit mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">置き在庫申込み<br/><span style="font-size: 13px;" class="outline">※別途預託の契約要</span></div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentTempInstalledRequest', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-playlist-edit mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">デモ申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentRequest', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-book-edit mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">試用申込み</div>
                </router-link>
              </div>
            </li>
            -->
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentPatientList', params:{agent:true, temp:true}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-account-multiple mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">処方変更・中止等申込み<br/><span style="font-size: 13px;">(既存患者への処方)</span></div>
                </router-link>
              </div>
            </li>
            <!--
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentInstrumentList', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-devices mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">置き在庫<br/>機器一覧</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentUsedList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-clipboard-outline mdi-48px" style="position: relative;" ></i>
                    <i class="mdi mdi-playlist-check mdi-20px" style="position: absolute;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">使用明細</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentInstrumentList', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-folder-edit mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">仮持出申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin,role.role_headOffice, role.role_salesOffice, role.role_headOffice_division])">
              <div class="contents">
                <router-link :to="{name:'CpapAgentTempInstrumentHome', params:{agent:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-archive mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">仮持出管理</div>
                </router-link>
              </div>
            </li>
            -->
            <li>
              <div class="contents">
                <router-link to="/philips/cpap/cpapHome">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-keyboard-return mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">CPAP処方・配送サービスに戻る</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "cpapTempInstalledHome",
  methods: {
    isActive: function(roles){
      return (roles.indexOf(this.roleId) >= 0);
    }    
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    return {
      role: role,
      roleId: roleId,
      cpapAgentReqFlg:true
    };
  },
  components: {}
};
</script>

<style lang="scss" >
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: 900px;
  margin: 0 auto;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 150px 1fr 100px;
  height: 100vh;
}

/*デザイン設定*/
.tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tile-container > li {
  height: 150px;
  width: 150px;
  padding: 5px;
  background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 150px;
  width: 150px;
  text-align: center;
  vertical-align: middle;
}

/*グリッド設定*/
.tile-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}
.subtext {
  font-size: 12px;
}
.outline {
  display        : inline-block;
  color          : red;            /* 文字の色 */
  letter-spacing : 1px;                /* 文字間 */
  font-weight    : bold; 
  text-shadow    : 
       1px  1px 0px white,
      -1px  1px 0px white,
       1px -1px 0px white,
      -1px -1px 0px white,
       1px  0px 0px white,
       0px  1px 0px white,
      -1px  0px 0px white,
       0px -1px 0px white;        /* 文字の影 */
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/cpap/cpapTempInstalledHome.vue